const COMMENTS = [
  {
    id: 1,
    name: '电影发烧友阿强',
    time: '2天前',
    rating: 5,
    content: '找了很久的《肖申克的救赎》高清修复版，居然在8090影院找到了！画质惊艳，完全免费还没有广告弹窗，观影体验比那些付费网站还好。已经推荐给身边所有影迷朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20portrait%20style%20avatar%20with%20warm%20tones%2C%20simple%20gradient%20background%2C%20cinema%20enthusiast%20vibe%2C%20clean%20geometric%20illustration&width=80&height=80&seq=avatar-comment-01&orientation=squarish',
  },
  {
    id: 2,
    name: '周末影迷小陈',
    time: '3天前',
    rating: 5,
    content: '最让我惊喜的是完全不卡顿！家里网速一般，但8090的多线路切换功能太贴心了，看4K大片全程流畅。没有广告这一点真的是业界良心，观影体验提升了好几个档次。',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20portrait%20style%20avatar%20with%20soft%20cinematic%20lighting%2C%20warm%20gradient%20background%2C%20movie%20lover%20personality%2C%20clean%20geometric%20illustration&width=80&height=80&seq=avatar-comment-02&orientation=squarish',
  },
  {
    id: 3,
    name: '老片收藏家',
    time: '5天前',
    rating: 5,
    content: '作为一个80后，特别喜欢8090年代的港片和国产经典。这个网站的片库真的惊人，很多已经绝版的电影都能找到。画质修复得也很好，每一帧都是回忆杀。',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20portrait%20style%20avatar%20with%20retro%20film%20aesthetic%2C%20warm%20amber%20gradient%20background%2C%20classic%20movie%20collector%20vibe%2C%20clean%20geometric%20illustration&width=80&height=80&seq=avatar-comment-03&orientation=squarish',
  },
  {
    id: 4,
    name: '大学生观影团',
    time: '1周前',
    rating: 4,
    content: '室友推荐的这个网站，周末一口气刷了五部电影。分类特别清晰，找片很方便。如果能增加一个收藏功能就更完美了，不过免费无广告已经很满足了。',
    avatar: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20portrait%20style%20avatar%20with%20youthful%20energy%2C%20warm%20gradient%20background%2C%20student%20movie%20enthusiast%2C%20clean%20geometric%20illustration&width=80&height=80&seq=avatar-comment-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影迷心声
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            听听千万影迷对8090影院的真实评价，免费电影大全、高清电影在线观看，不缓冲影院体验获赞无数
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {COMMENTS.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/30 hover:border-primary-500/15 transition-colors duration-300"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-semibold text-foreground-800">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < comment.rating
                            ? 'ri-star-fill text-primary-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-500 leading-relaxed">{comment.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}